export const REVIEWS_CAROUSEL_LIMITS = {
    MAX_REVIEWS: 5,
};
